<template>
	<div class="store-attr-body">
		<div class="container">
			<div class="fx-title">
				<p>顺序</p>
			</div>
			<p>
				<span>店内显示顺序：</span>
				<el-input
					size='mini'
					v-model="shopSeqnum"
					@input="orderInput"
				/>
				<span>（数值越大，越靠前显示）</span>
			</p>
			<!-- <div class="fx-title">
				<p>店铺品类</p>
			</div>
			<el-button type="primary" size='small' plain @click="setClass">设置店内品类</el-button>
			<div class="tag-box">
				<el-tag
					v-for="(tag, index) in tags"
					:key="index"
					closable
					type="info"
					:disable-transitions="false"
					@close="handleClose(tag)">
					{{tag.name}}
				</el-tag>
			</div> -->
		</div>
		<div class="btn-box">
			<el-button type="primary" size='medium' plain @click="cancel">取消</el-button>
			<el-button type="primary" size='medium' plain @click="save">保存</el-button>
		</div>
		<el-dialog
			class="set-class"
			top="60px"
			:close-on-click-modal="false"
			width="800px"
			title="店铺分类"
			:visible.sync="innerVisible"
			append-to-body>
			<div class="main-table">
				<div class="table-box">
					<el-table
						ref="multipleTable"
						:stripe='true'
						class="grid-content"
						:data="tableData"
						:height="tableHeight"
						border
						@selection-change="handleSelectionChange">
						<el-table-column
						type="selection"
						align="center"
						width="55">
						</el-table-column>
						<el-table-column
							label-class-name = "column-index"
							label="序号"
							type="index"
							width="70"
							align="center">
						</el-table-column>
						<el-table-column
							prop="shopCategoryName"
							label="一级分类"
							align="center"
							min-width="180">
						</el-table-column>
						<el-table-column
							prop="smallCategory_name"
							label="二级分类"
							align="center"
							min-width="180">
						</el-table-column>
					</el-table>
				</div>
				<div class="btn-box">
					<el-button type="primary" size='medium' plain @click="classificationCancel">取消</el-button>
					<el-button type="primary" size='medium' plain @click="classificationSave">保存</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'storeAttr',
	props: {
		productId: {
			type: String
		}
	},
	data () {
		return {
			shopSeqnum: 0,
			// tags: [],
			innerVisible: false,
			tableHeight: 400,
			tableData: [],
			selectedArr: []
		}
	},
	created () {
		this.getInfo()
	},
	methods: {
		getInfo () {
			let params = {
				id: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productShopAttr/get`,
				data: params
			}).then(res => {
				if (res.result) {
					// this.tags = []
					this.shopSeqnum = res.data.shopSeqnum
					// if (res.data.categories.length > 0) {
					// 	res.data.categories.forEach(item => {
					// 		this.tags.push({ name: item.categoryname + '一' + item.smallcategoryname, syscodeid: item.syscodeid, pid: item.categoryid, id: item.smallcategoryid, productid: item.productid })
					// 	})
					// }
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		orderInput () {
			this.shopSeqnum = this.shopSeqnum.replace(/[^\d-]/g, '')
			if (this.shopSeqnum.lastIndexOf('-') > 0) {
				let numArr = this.shopSeqnum.split('')
				numArr.splice(this.shopSeqnum.lastIndexOf('-'), 1)
				this.shopSeqnum = numArr.join('')
			}
			if (this.shopSeqnum.indexOf('-') > -1) {
				this.shopSeqnum = this.shopSeqnum.slice(0, 5)
			} else {
				this.shopSeqnum = this.shopSeqnum.slice(0, 4)
			}
		},
		cancel () {
			this.$emit('cancel')
		},
		save () {
			let params = {
				id: this.productId,
				seqnum: this.shopSeqnum
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productShopAttr/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('cancel')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSelectionChange (data) {
			this.selectedArr = data
		},
		classificationSave () {
			if (this.selectedArr.length < 1) {
				this.$message.warning('请至少勾选一个分类！')
				return false
			}
			let params = {
				id: this.productId,
				shopCategoryInfos: this.selectedArr,
				shopid: window.sessionStorage.getItem('storeid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/bindcategory/save`,
				data: params
			}).then(res => {
				if (res.result) {
					this.selectedArr = []
					this.$message.success(res.msg)
					this.innerVisible = false
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		classificationCancel () {
			this.innerVisible = false
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-attr-body {
	display flex
	flex-direction column
	flex 1
	text-align left
	height: 100%;
	.container {
		flex: 1
		p {
			display flex;
			height: 28px;
			line-height: 28px;
			.el-input {
				width: 100px;
			}
		}
		.el-button {
			margin-left 10px;
		}
		.tag-box {
			padding-left 10px;
			margin-top: 10px;
			max-height 280px;
			overflow auto
			.el-tag {
				margin-right 10px;
				margin-bottom 10px;
			}
		}
	}
	.btn-box {
		height: 40px;
		display flex;
		justify-content center;
		margin-top: 10px;
		.el-button {
			width: 200px;
		}
	}
}
</style>
<style lang="stylus">
.set-class {
	.main-table {
		display flex
		flex: 1
		flex-direction: column
		height: 100%
		.table-box {
			flex: 1
			padding-bottom 10px
			overflow-y: auto;
		}
	}
	.el-pagination {
		text-align center
	}
	.btn-box {
		height: 40px;
		display flex;
		justify-content center;
		margin-top: 10px;
		.el-button {
			width: 200px;
		}
	}
}
</style>
